import { createApp } from 'vue';
const apps = import.meta.glob('../../src/widgets/**/App.vue')

document.addEventListener('DOMContentLoaded', () => {
  const vueElements = document.querySelectorAll('[data-component]')

  if(vueElements.length < 1 ) return;

  vueElements.forEach((el) => {
    const path = `../../src/${el.dataset.component}/App.vue`
    if (apps[path] && typeof el.dataset.vApp === 'undefined') {
      apps[path]().then((mod) => {
        let props = {};
        try {
          props = el.dataset.props ? JSON.parse(el.dataset.props) : {};
        } catch (e) {
          console.error(`Erro ao parsear JSON do data-props para o componente ${path}:`, el.dataset.props, e);
        }

        const app = createApp(mod.default, props)
        app.config.globalProperties.$i18n = window.t
        app.mount(el)
      })
    } else {
      console.warn("Vue component not found at", path)
    }
  })
})
